/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerNetsuiteSourceComponent', [
    '$rootScope',
    'DesignerDatabaseBaseSourceComponent',

    function ($rootScope, DesignerDatabaseBaseSourceComponent) {
      function DesignerNetsuiteSourceComponent() {
        DesignerDatabaseBaseSourceComponent.apply(this);
      }

      DesignerNetsuiteSourceComponent.prototype = new DesignerDatabaseBaseSourceComponent();

      DesignerNetsuiteSourceComponent.prototype.getData = function () {
        const data = DesignerDatabaseBaseSourceComponent.prototype.getData.call(this);

        _.extend(data, {});

        return data;
      };

      DesignerNetsuiteSourceComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerDatabaseBaseSourceComponent.prototype.setFormData.call(this, data);
      };

      DesignerNetsuiteSourceComponent.prototype.setData = function (data) {
        DesignerDatabaseBaseSourceComponent.prototype.setData.call(this, data);
      };

      return DesignerNetsuiteSourceComponent;
    },
  ]);
})(window.angular);
